import clsx from 'clsx';
import React from 'react';

import { createStyles } from "./styles";

var Spinner = function Spinner(props) {
  var classes = createStyles(props);
  return /*#__PURE__*/React.createElement("div", { className: clsx(classes.spinner, props.className), id: "spinner" });
};
export default Spinner;
//# sourceMappingURL=index.js.map